$(".c-fixedMenu-button__item").on("click", function () {

  var label = $(this).data("label");

  if ($('.c-fixedMenu-list[data-label="' + label + '"]').is(':visible')) {
    $('.c-fixedMenu-list').hide();
  } else {
    $('.c-fixedMenu-list').hide();
    $('.c-fixedMenu-list[data-label="' + label + '"]').show();
  }

})

$(document).click(function (event) {
  if (!$(event.target).closest('.c-fixedMenu-button__item').length && !$(event.target).closest('.c-fixedMenu-list').length) {
    
    $('.c-fixedMenu-list').hide();
  } else {
    // console.log('内側がクリックされました。');
  }
});